import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";

export const getZoomContent = async ({ eventId, eventType }) => {
  const params = {
    action: "gerarToken",
    alunoId: _cookies.getItem("auth").user?.alunoid,
  };

  switch (eventType.toLocaleUpperCase()) {
    case "AULA":
      params.aulaId = eventId;
      break;
    case "LIVE":
      params.liveId = eventId;
      break;
    default:
  }

  const res = await axios.middleware.get(
    `https://${window.location.host}/Membros/AVA_ADMIN/ZoomHandler.ashx`,
    {
      params,
    }
  );
  return res.url;
};

export const useZoomContent = ({
  config,
  studentId = _cookies.getItem("auth").user?.alunoid,
  eventType,
  eventId,
  secretKey,
} = {}) => {
  return useQuery({
    ...config,
    queryFn: () => getZoomContent({ studentId, eventId, eventType, secretKey }),
    queryKey: ["zoomContent", { studentId, eventId, eventType }],
  });
};
